export const INITIAL_CHECKOUT_DATA = 'INITIAL_CHECKOUT_DATA';
export const INITIAL_CHECKOUT_ADDONS = 'INITIAL_CHECKOUT_ADDONS';
export const UPDATE_CHECKOUT_DATA = 'UPDATE_CHECKOUT_DATA';
export const UPDATE_CHECKOUT_NESTED_DATA = 'UPDATE_CHECKOUT_NESTED_DATA';
export const UPDATE_CHECKOUT_ADDONS_DATA = 'UPDATE_CHECKOUT_ADDONS_DATA';
